import request from 'superagent';
import config from '../config';

export const getToken = function() {
	return request.get(`${config.apiBase}/token`);
};


// WEBPACK FOOTER //
// ./src/services/authService.js